import BreadCrumb from 'components/__ASSESSOR__/BreadCrumb/BreadCrumb';
import { IBreadCrumbItem } from 'components/__ASSESSOR__/BreadCrumb/BreadCrumb';
import { BlockIcon, RestritoIcon } from 'components/Icons';
import Page from 'components/__SHARED__/PrivateContainer';
import {
  AssembleiaPautaStatus,
  AssembleiaTipoPauta,
} from 'helpers/enums/AssembleiaPautaStatus';
import { AssembleiaAssessorRoutePath, AssessorRoutePath } from 'library/Routes';
import {
  ActionsColumn,
  Button,
  ButtonThemes,
  CheckCircleIcon,
  Col,
  DraggableIcon,
  LockIcon,
  Paginator,
  PercentLoaderIcon,
  Row,
  Table,
  TimesCircleIcon,
  Title,
  ToastTypes,
} from 'plataforma-fundacao-componentes';
import {
  ChangeEvent,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useReducer,
  useRef,
  useState,
} from 'react';
import { clsx } from 'helpers/utils/HTMLUtils';
import Context from '../../Context';

import ReorderPautaReducer, {
  INITIAL_STATE,
} from 'store/modules/ReorderPautaReducer';

import { Tooltip } from '@material-ui/core';
import LayoutContext from 'components/Layout/LayoutContext';
import { useHistory } from 'react-router-dom';
import { postReorderAgenda } from 'services/assessor';
import {
  loadPautas,
  REORDER_PAUTA_LIST,
  REORDER_PAUTA_REQUEST,
  REORDER_PAUTA_SET_EVENT,
} from 'store/modules/ReorderPautaActions';
import { languageValues } from 'helpers/utils/languageUtils';
import './styles.scss';
import { useDispatch } from 'react-redux';
import { assessorActionCarregarPautas } from 'store/modules/assessor/actions';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import useOutsideClick from 'hooks/useOutsideClick';
import dotsOnLargeText from 'helpers/utils/dotsOnLargeText';

const rootClassName = 'page-reorder';

type ItemProps = {
  codigoAgencia: string | null;
  descricao: string | null;
  flgRestrita: boolean;
  flgSecreta: boolean;
  idPauta: number;
  itens: {
    descricao: string;
    flgAbstencao: number;
    idItemPauta: number;
    representantesChapa: Number[];
  }[];
  numeroNucleo: string | null;
  ordem: number;
  resultadoLiberado: boolean;
  resultadoLiberadoAssociado: boolean;
  resultadoLiberadoPresencial: boolean;
  status: number;
  statusPresencial: string;
  tempoRestante: number;
  tempoVotacao: number;
  tipoPauta: number;
  titulo: string;
};

export default function ReordenarPautas() {
  const [active, setActive] = useState<any>();
  const [newIndex, setNewIndex] = useState<number | undefined>(undefined);
  const [sent, setSent] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [count, setCount] = useState<number>(0);
  const [allowSort, setAllowSort] = useState<boolean>(true);

  const [state, dispatch] = useReducer(ReorderPautaReducer, INITIAL_STATE);
  const { showToast } = useContext(LayoutContext);
  const { evento } = useContext(Context);

  const wrapperRef = useRef<any>([]);
  const countRef = useRef<number>();
  const linesRef = useRef(state.items);

  linesRef.current = state.items;
  countRef.current = count;

  const handleClickOutside = (e: boolean) => {
    if (!e) setActive(false);
  };

  const dispatchAction = useDispatch();

  useOutsideClick(wrapperRef, handleClickOutside);

  const history = useHistory();

  const eventName = useMemo(() => {
    return evento?.nome || '';
  }, [evento]);

  const breadcrumb = useMemo(
    (): IBreadCrumbItem[] => [
      {
        nome: languageValues.pages.reorderAgenda.breadcrumbs.initial,
        url: AssessorRoutePath,
      },
      {
        nome: dotsOnLargeText(eventName, 30),
        url: `${AssembleiaAssessorRoutePath.replace(
          ':id',
          String(evento?.id)
        )}`,
      },
      { nome: languageValues.pages.reorderAgenda.breadcrumbs.reorderAgenda },
    ],
    [eventName, evento?.id]
  );

  const pautaType = useCallback((type: AssembleiaTipoPauta) => {
    switch (type) {
      case AssembleiaTipoPauta.Normal:
        return languageValues.pages.reorderAgenda.default;
      case AssembleiaTipoPauta.Eleicao:
        return languageValues.pages.reorderAgenda.advice;
      case AssembleiaTipoPauta.Coordenador:
        return languageValues.pages.reorderAgenda.coordinator;
    }
  }, []);

  const statusType = useCallback((type: AssembleiaPautaStatus) => {
    switch (type) {
      case AssembleiaPautaStatus.Bloqueada:
        return languageValues.pages.reorderAgenda.block;
      case AssembleiaPautaStatus.Encerrada:
        return languageValues.pages.reorderAgenda.closed;
    }
  }, []);

  const handlSortable = useCallback(
    (items: ItemProps[], oldIndex: number, newIndex: number) => {
      const newOrder = [...items];
      const [removed] = newOrder.splice(oldIndex, 1);
      newOrder.splice(newIndex, 0, removed);
      setCount((c) => c + 1);
      dispatch({
        type: REORDER_PAUTA_LIST,
        payload: newOrder,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    setAllowSort(evento?.flagIniciarVotacaoDigital!);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evento]);

  useEffect(() => {
    if (evento?.id) {
      dispatch({
        type: REORDER_PAUTA_SET_EVENT,
        payload: evento?.id,
      });
    }

    if (state.eventId) {
      loadPautas(showToast, state, dispatch);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.eventId, evento?.id]);

  useEffect(() => {
    dispatch({
      type: REORDER_PAUTA_REQUEST,
      payload: {
        eventId: evento?.id,
        agendaIds: state.items!?.map(
          (itens: { idPauta: number }) => itens!?.idPauta
        ),
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.items]);

  useEffect(() => {
    if (state.eventId && evento?.flagIniciarVotacaoDigital) {
      setTimeout(() => {
        history.push(
          `${AssembleiaAssessorRoutePath.replace(':id', String(evento?.id))}`
        );
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.eventId, evento?.id]);

  return (
    <Page
      header={
        <Row>
          <Col style={{ flexDirection: 'column' }}>
            <Title
              showBackButton
              onBackClick={() => {
                history.push(
                  `${AssembleiaAssessorRoutePath.replace(
                    ':id',
                    String(evento?.id)
                  )}`
                );
              }}
            >
              {languageValues.pages.reorderAgenda.title}
            </Title>
            <BreadCrumb itens={breadcrumb} />
          </Col>
        </Row>
      }
    >
      {!evento?.flagIniciarVotacaoDigital ? (
        <div className={rootClassName}>
          <Row>
            <Col>
              <p className={`${rootClassName}-sub-title`}>
                {languageValues.pages.reorderAgenda.reorderingOfAgendas}
              </p>
            </Col>
            <Col className={`${rootClassName}-table-container`}>
              <Table
                sortable
                onSort={(evt) => {
                  if (evt?.newIndex === evt?.oldIndex) {
                    return;
                  } else {
                    handlSortable(
                      linesRef.current,
                      evt!?.oldIndex,
                      evt!?.newIndex
                    );
                  }
                }}
                columns={[
                  {
                    key: 'order',
                    value:
                      languageValues.pages.reorderAgenda.table.heading.order,
                    props: {
                      style: { width: '100px' },
                      align: 'center',
                    },
                  },
                  {
                    key: 'typeAgenda',
                    value:
                      languageValues.pages.reorderAgenda.table.heading
                        .typeAgenda,
                    props: {
                      style: { width: '100px' },
                      align: 'center',
                    },
                  },
                  {
                    key: 'detalhe',
                    value:
                      languageValues.pages.reorderAgenda.table.heading.detail,
                    props: {
                      align: 'center',
                    },
                  },
                  {
                    key: 'agencia',
                    value:
                      languageValues.pages.reorderAgenda.table.heading.agency,
                    props: { style: { width: '70px' }, align: 'center' },
                  },
                  {
                    key: 'nucleou',
                    value:
                      languageValues.pages.reorderAgenda.table.heading.nucleou,
                    props: { style: { width: '70px' }, align: 'center' },
                  },
                  {
                    key: 'pautas',
                    value:
                      languageValues.pages.reorderAgenda.table.heading.agenda,
                    props: { style: { width: '500px' }, align: 'left' },
                  },
                  {
                    key: 'situation',
                    value:
                      languageValues.pages.reorderAgenda.table.heading
                        .situation,
                    props: { style: { width: '100px' }, align: 'center' },
                  },
                  {
                    key: 'action',
                    value: '',
                    props: { style: { width: '50px' }, align: 'right' },
                  },
                ]}
                lines={state.items?.map((pauta: ItemProps, index: number) => {
                  return {
                    key: `${index}-${count}`,
                    order: (
                      <div ref={(ref) => (wrapperRef.current[index] = ref)}>
                        <div
                          className={`${rootClassName}-input-container`}
                          onClick={() => setActive(pauta.idPauta)}
                        >
                          <input
                            data-testid={`reorder-input-${index}`}
                            type={'text'}
                            readOnly={active !== pauta.idPauta}
                            value={
                              active === pauta.idPauta ? newIndex! : index + 1
                            }
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              setNewIndex(Number(e.target.value))
                            }
                            className={
                              active === pauta.idPauta &&
                              (newIndex! > state.items.length ||
                                newIndex! - 1 === index)
                                ? 'error'
                                : ''
                            }
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                          <button
                            className={clsx([
                              `${rootClassName}-button`,
                              active === pauta.idPauta ? 'show' : '',
                              active === pauta.idPauta &&
                              (!newIndex ||
                                newIndex! === 0 ||
                                newIndex! - 1 === index ||
                                newIndex! > state.items.length)
                                ? 'error'
                                : '',
                            ])}
                            disabled={
                              active === pauta.idPauta &&
                              (!newIndex ||
                                newIndex! === 0 ||
                                newIndex! - 1 === index ||
                                newIndex! > state.items.length)
                            }
                            onClick={() => {
                              if (
                                active === pauta.idPauta &&
                                (!newIndex ||
                                  newIndex! === 0 ||
                                  newIndex! - 1 === index ||
                                  newIndex! > state.items.length)
                              )
                                return;
                              setSent(true);
                              setTimeout(() => {
                                setActive(null);
                                setNewIndex(undefined);
                                handlSortable(
                                  linesRef.current,
                                  index,
                                  newIndex! - 1
                                );
                                setSent(false);
                              }, 1000);
                            }}
                            tabIndex={
                              active === pauta.idPauta &&
                              (!newIndex ||
                                newIndex! === 0 ||
                                newIndex! > state.items.length)
                                ? -1
                                : 1
                            }
                          >
                            {active === pauta.idPauta &&
                            (!newIndex ||
                              newIndex! === 0 ||
                              newIndex! - 1 === index ||
                              newIndex! > state.items.length) ? (
                              <TimesCircleIcon />
                            ) : (
                              <PercentLoaderIcon
                                value={'100'}
                                indefinido={sent}
                              />
                            )}
                          </button>
                        </div>
                      </div>
                    ),
                    typeAgenda: (
                      <div>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '50px',
                          }}
                        >
                          {pautaType(pauta.tipoPauta)}
                        </div>
                      </div>
                    ),
                    detalhe:
                      !pauta.flgSecreta && !pauta.flgRestrita ? (
                        '-'
                      ) : (
                        <div>
                          <div className={`${rootClassName}-icons`}>
                            {pauta.flgSecreta ? <BlockIcon /> : undefined}
                            {pauta.flgRestrita ? <RestritoIcon /> : undefined}
                          </div>
                        </div>
                      ),
                    agencia: pauta.codigoAgencia ? pauta.codigoAgencia : '-',
                    nucleou: pauta.numeroNucleo ? pauta.numeroNucleo : '-',
                    pautas: (
                      <span>
                        <div
                          style={{
                            width: '100%',
                            maxWidth: '100%',
                            cursor: 'default',
                          }}
                        >
                          <Tooltip
                            title={pauta.titulo}
                            arrow
                            disableHoverListener={pauta.titulo.length < 40}
                          >
                            <div
                              style={{
                                cursor: 'default',
                              }}
                              className={`${rootClassName}-text`}
                            >
                              <span>{pauta.titulo}</span>
                            </div>
                          </Tooltip>
                        </div>
                      </span>
                    ),
                    situation: (
                      <div>
                        <div
                          className={clsx([
                            `${rootClassName}-status`,
                            pauta.status === 0 ? 'block' : '',
                          ])}
                        >
                          {pauta.status === 0 ? (
                            <LockIcon />
                          ) : (
                            <TimesCircleIcon />
                          )}
                          <span>{statusType(pauta.status)}</span>
                        </div>
                      </div>
                    ),
                    acoes: (
                      <ActionsColumn
                        data-testid={`reorder-icon-agenda-${pauta.idPauta}`}
                        buttons={[
                          {
                            icon: <DraggableIcon />,
                            className: 'grab-handle',
                          },
                        ]}
                      />
                    ),
                  };
                })}
              />
            </Col>
            {state.itemsLoading ? (
              <Col>
                <Paginator
                  loading
                  paginaAtual={0}
                  quantidadeDePaginas={0}
                  onChange={() => {}}
                />
              </Col>
            ) : undefined}
          </Row>
          <Row className={`${rootClassName}-footer`}>
            <Col buttonActionsCol end>
              <Button
                theme={ButtonThemes.Secondary}
                leftIcon={<TimesCircleIcon />}
                disabled={allowSort}
                onClick={() => {
                  linesRef.current = state.initialState;
                  setNewIndex(undefined);
                  setActive(null);
                  dispatch({
                    type: REORDER_PAUTA_LIST,
                    payload: state.initialState,
                  });
                }}
              >
                Cancelar
              </Button>
              <Button
                theme={ButtonThemes.Primary}
                leftIcon={<CheckCircleIcon />}
                disabled={
                  allowSort ||
                  loading ||
                  JSON.stringify(state.items) ===
                    JSON.stringify(state.initialState)
                }
                loading={loading}
                onClick={() => {
                  setLoading(true);
                  postReorderAgenda(state.request)
                    .then(() => {
                      setLoading(false);
                      showToast({
                        pauseOnFocusLoss: true,
                        theme: ToastTypes.Success,
                        showStatusBar: true,
                        timeout: 4000,
                        label: languageValues.toasts.success.reorderPauta,
                      });

                      dispatchAction(
                        assessorActionCarregarPautas(
                          state.eventId,
                          0,
                          ErrorHandler,
                          () => {}
                        )
                      );

                      dispatch({
                        type: REORDER_PAUTA_LIST,
                        payload: [],
                      });

                      loadPautas(showToast, state, dispatch);
                    })
                    .catch((err) => {
                      setLoading(false);
                      showToast({
                        pauseOnFocusLoss: true,
                        theme: ToastTypes.Error,
                        showStatusBar: true,
                        timeout: 4000,
                        label: languageValues.toasts.error.keyErrors(
                          err.response?.data.message,
                          languageValues.toasts.error.reorderPauta
                        ),
                      });
                    });
                }}
              >
                Salvar alterações
              </Button>
            </Col>
          </Row>
        </div>
      ) : undefined}
    </Page>
  );
}
